module.exports = __webpack_public_path__ + "static/dropbox@2x-c46130030df67139b02e1db3b0ad62ce.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/images/pages/developers/dropbox@2x.jpg
// module id = 2554
// module chunks = 168707334958949